import React, { useState } from "react";
import { Box, Grid } from "@material-ui/core";
import clsx from "clsx";

import CalculatorVesselDetails from "../../../../../components/Calculator/CalculatorVesselDetails";
import MarginAndAllowances from "../../../../../components/Calculator/MarginAndAllowances";
import ActionButtons from "../../../../../components/Calculator/ActionButtons";
import VesselVesselDeliveryOut from "../../../../../components/Calculator/VesselVesselDeliveryOut";
import VesselVesselReDeliveryIn from "../../../../../components/Calculator/VesselVesselReDeliveryIn";
import CustomShowModal from "../../../../../components/Common/CustomShowModal";
import SplitHireModal from "../../../../../components/Calculator/SplitHireModal";
import VesselVesselPortOperations from "../../../../../components/Calculator/VesselVesselPortOperations";
import VesselVesselResult from "../../../../../components/Calculator/VesselVesselResult";
import VesselContractForm from "../../../../../components/Calculator/AddCalculatorFleet/createVesselContractModel";
import CustomAddModal from "../../../../../components/Common/CustomAddModal";
import { LabelActionGuide } from "../../../../../components/Common/ShareWithOrg";
import CustomConfirmModal from "../../../../../components/Common/CustomConfirmModal";
import CustomTabs from "../../../../../common/Tabs";

import {
  vesselVesselExpenseResultsFields,
  vesselVesselResultsFields,
  vesselVesselRevenueResultsFields,
} from "../../../../../constants";

import { useVesselVesselContractController } from "../hooks/useVesselVesselContractController";

export function VesselVesselContractView(props) {
  const controller = useVesselVesselContractController(props);

  const {
    id,
    calculatorData,
    setCalculatorData,
    selectedVessels,
    setSelectedVessels,
    syncBunker,
    setSyncBunker,
    isOverride,
    isPrivate,
    calculationErrors,

    hideOrder,
    setHideOrder,
    hideCalculator,
    fleetCheckbox,
    setFleetCheckbox,

    marginModal,
    setMarginModal,
    supplyModal,
    setSupplyModal,
    splitHireModal,
    setSplitHireModal,
    splitHireModalVesselOut,
    setSplitHireModalVesselOut,
    selectedSplitHire,
    selectedSplitHireVesselOut,
    openAddOperation,
    setOpenAddOperation,
    setOpenAddOperationindex,
    editVesselContractModelOpen,
    setEditVesselContractModelOpen,
    estimationCopyModelOpen,
    setEstimationCopyModelOpen,
    inputValue,
    setInputValue,

    vesselFormData,
    setVesselFormData,
    vesselAttachments,
    vesselTextContract,
    prevAttachments,
    setPrevAttachments,

    tabs,
    active,
    handleMainTabChange,
    propVesselId,
    isViewOnly,

    fetchPortDistance,

    onChangePortOperations,
    sendCalculationRequest,
    onClickCalculate,
    onClickCalculateAndSave,
    onChangeSelectedVessel,
    onChangeSelectedVesselOut,
    onChangeSyncBunker,
    onChangeOverride,
    onFetchPortOperationDistance,
    onAddOperations,
    onDeleteOperations,
    onSetHideCalculator,
    onSetOpenMap,
    onChangePortCanalInQueryState,
    openSplitHireModal,
    openSplitHireModalVesselOut,
    addNewSplitHire,
    addNewSplitHireVesselOut,
    onChangeSplitHire,
    onChangeSplitHireVesselOut,
    onClickVesselContract,
    handleUpdateVesselContract,
    removeVesselAttachment,
    handleVesselContractInputChange,
    handleVesselTextContractUpload,
    handleVesselContractAttachmentUpload,
    onClickCopyToEstimate,
    handleCopyToEstimation,
  } = controller;

  const { setLoader = () => {} } = props;
  const [showSaveWarningModal, setShowSaveWarningModal] = useState(false);
  // In ops, confirm before saving (same as vessel-cargo ops)
  const onSaveClick = propVesselId
    ? () => setShowSaveWarningModal(true)
    : onClickCalculateAndSave;

  return (
    <Grid className="calculator-section min-h-[calc(100vh-60px)] px-0 md:px-4 pt-1.5 pb-4">
      {/* first UI part orders selector */}
      <div className="flex flex-row">
        {/* header */}
        <div className={clsx("flex flex-col main-content-wrapper-inner w-full")}>
          <div className="quick-menu-bar items-center grid grid-cols-1 md:grid-cols-6 justify-between p-0 m-0">
            <div className="md:col-span-2 w-fit">
              {propVesselId && (
                <CustomTabs
                  tabs={tabs}
                  active={active}
                  onChange={handleMainTabChange}
                />
              )}
            </div>
            <div className="md:col-span-4">
              {isViewOnly ? (
                <div className="py-5"></div>
              ) : (
              <ActionButtons
                hideOrder={hideOrder}
                setHideOrder={setHideOrder}
                onSetOpenMap={onSetOpenMap}
                onClickCalculate={onClickCalculate}
                onSetHideCalculator={onSetHideCalculator}
                onClickCalculateAndSave={onSaveClick}
                isFromSingleVesselCalcy
                isPublic={!isPrivate}
                isContractPage
                onClickCopyToEstimate={onClickCopyToEstimate}
              />
              )}
            </div>
          </div>

          {/* second UI part */}
          <div>
            {!id && !propVesselId ? (
              <div className="h-100">
                <div className="flex">
                  <p className="m-a text-xl">Please select an id.</p>
                </div>
              </div>
            ) : (
              <div className="calc-secound-section p-2 pt-1">
                <div className="flex flex-col gap-2">
                  {hideCalculator ? null : (
                    <div className="grid grid-cols-6 gap-3 all-content-tables">
                      <div className="upper-section-grid col-span-2">
                        <CalculatorVesselDetails
                          setLoader={setLoader}
                          setSelectedVessels={setSelectedVessels}
                          selectedVessels={selectedVessels}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          onChangeHandler={onChangeSelectedVessel}
                          fleetCheckbox={fleetCheckbox}
                          setFleetCheckbox={setFleetCheckbox}
                          disableEdit
                          isContractEstimate
                        />
                      </div>

                      <div className="upper-section-grid">
                        <MarginAndAllowances
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          selectedVessels={selectedVessels}
                          setSelectedVessels={setSelectedVessels}
                          setMarginModal={setMarginModal}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          syncBunker={syncBunker}
                          setSyncBunker={setSyncBunker}
                          setSupplyModal={setSupplyModal}
                          onChangeSyncBunker={onChangeSyncBunker}
                          isOverride={isOverride}
                          isFromVesselVessel
                        />
                      </div>

                      <div className="upper-section-grid">
                        <VesselVesselDeliveryOut
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          selectedVessels={selectedVessels}
                          openSplitHireModal={openSplitHireModal}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          addNewSplitHire={addNewSplitHire}
                          onChangeSplitHire={onChangeSplitHire}
                          isOverride={isOverride}
                          isFromSingleVesselCalcy
                          label="Vessel-in"
                          onClickEditVesselContract={onClickVesselContract}
                          isFromVesselVessel
                        />
                      </div>

                      <div className="upper-section-grid">
                        <VesselVesselReDeliveryIn
                          onChangeSelectedVessel={onChangeSelectedVesselOut}
                          selectedVessels={selectedVessels}
                          openSplitHireModal={openSplitHireModalVesselOut}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          onClickEditVesselContract={onClickVesselContract}
                          isFromVesselVessel
                          addNewSplitHire={addNewSplitHire}
                          onChangeSplitHire={onChangeSplitHire}
                          isOverride={isOverride}
                          isFromSingleVesselCalcy
                          label="Vessel-out"
                        />
                      </div>

                      <div className="upper-section-grid">
                        <VesselVesselResult
                          selectedVessels={selectedVessels}
                          calculationErrors={calculationErrors}
                          label="Revenue"
                          fields={vesselVesselRevenueResultsFields}
                        />
                        <VesselVesselResult
                          selectedVessels={selectedVessels}
                          calculationErrors={calculationErrors}
                          label="Expense"
                          fields={vesselVesselExpenseResultsFields}
                        />
                        <VesselVesselResult
                          selectedVessels={selectedVessels}
                          calculationErrors={calculationErrors}
                          label="Result"
                          fields={vesselVesselResultsFields}
                        />
                      </div>
                    </div>
                  )}

                  <div>
                    {calculatorData && (
                      <div className="middle-section-grid">
                        <VesselVesselPortOperations
                          marginModal={marginModal}
                          setMarginModal={setMarginModal}
                          sendCalculationRequest={sendCalculationRequest}
                          onChangePortOperations={onChangePortOperations}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          syncBunker={syncBunker}
                          setSyncBunker={setSyncBunker}
                          onAddOperations={onAddOperations}
                          onDeleteOperations={onDeleteOperations}
                          selectedVessels={selectedVessels}
                          supplyModal={supplyModal}
                          setSupplyModal={setSupplyModal}
                          onChangeSyncBunker={onChangeSyncBunker}
                          onFetchPortOperationDistance={
                            onFetchPortOperationDistance
                          }
                          fetchPortDistance={fetchPortDistance}
                          openAddOperation={openAddOperation}
                          setOpenAddOperation={setOpenAddOperation}
                          setOpenAddOperationindex={setOpenAddOperationindex}
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          isOverride={isOverride}
                          onChangePortCanalInQueryState={
                            onChangePortCanalInQueryState
                          }
                          setIsOverride={onChangeOverride}
                          disableEdit={!isPrivate}
                          onClickCalculateAndSave={onSaveClick}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {isPrivate ? (
            <CustomAddModal
              open={editVesselContractModelOpen}
              title={"Update Vessel Contract"}
              maxWidth="md"
              saveLabel={"Update"}
              handleClose={() => setEditVesselContractModelOpen(false)}
              onSubmitConfirm={handleUpdateVesselContract}
            >
              <VesselContractForm
                formData={vesselFormData[vesselFormData.type]}
                setFormData={setVesselFormData}
                handleChange={handleVesselContractInputChange}
                attachments={vesselAttachments}
                textContract={vesselTextContract}
                removeAttachment={removeVesselAttachment}
                handleTextContractUpload={handleVesselTextContractUpload}
                handleAttachmentUpload={handleVesselContractAttachmentUpload}
                isEditing
                setTextContract={vesselTextContract}
                isVesselVessel
                prevAttachments={prevAttachments}
                setPrevAttachments={setPrevAttachments}
              />
            </CustomAddModal>
          ) : (
            <CustomShowModal
              open={editVesselContractModelOpen}
              handleClose={() => setEditVesselContractModelOpen(false)}
              title="View Vessel Contract"
              maxWidth="md"
            >
              <VesselContractForm
                formData={vesselFormData[vesselFormData.type]}
                setFormData={setVesselFormData}
                handleChange={handleVesselContractInputChange}
                attachments={vesselAttachments}
                textContract={vesselTextContract}
                removeAttachment={removeVesselAttachment}
                handleTextContractUpload={handleVesselTextContractUpload}
                handleAttachmentUpload={handleVesselContractAttachmentUpload}
                isEditing
                setTextContract={vesselTextContract}
                isVesselVessel
                prevAttachments={prevAttachments}
                setPrevAttachments={setPrevAttachments}
              />
            </CustomShowModal>
          )}

          <CustomAddModal
            open={estimationCopyModelOpen}
            title={"Copy To Estimation"}
            maxWidth="sm"
            saveLabel="Copy"
            handleClose={() => setEstimationCopyModelOpen(false)}
            onSubmitConfirm={handleCopyToEstimation}
          >
            <Box>
              <LabelActionGuide title="Copy this pre-fix estimate">
                Create a separate copy of this pre-fix estimate. Find it in Contracts → My Contracts → Pre-Fix Estimate.
              </LabelActionGuide>
              <label className="block text-xs font-medium text-slate-700">
                <span className="mb-1 block">Estimate name</span>
                <input
                  placeholder="Enter Estimate Name"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleCopyToEstimation();
                    }
                  }}
                  className="p-2 border w-full border-gray-300 rounded-md"
                />
              </label>
            </Box>
          </CustomAddModal>

          <CustomShowModal
            open={splitHireModal}
            handleClose={() => setSplitHireModal(false)}
            maxWidth="xs"
            title="Split Hire"
          >
            <SplitHireModal
              addNewSplitHire={addNewSplitHire}
              selectedSplitHire={selectedSplitHire}
              onChangeSplitHire={onChangeSplitHire}
            />
          </CustomShowModal>

          <CustomShowModal
            open={splitHireModalVesselOut}
            handleClose={() => setSplitHireModalVesselOut(false)}
            maxWidth="xs"
            title="Split Hire"
          >
            <SplitHireModal
              addNewSplitHire={addNewSplitHireVesselOut}
              selectedSplitHire={selectedSplitHireVesselOut?.vesselOut}
              onChangeSplitHire={onChangeSplitHireVesselOut}
            />
          </CustomShowModal>

          <CustomConfirmModal
            open={showSaveWarningModal}
            handleClose={() => setShowSaveWarningModal(false)}
            message="Are you sure you want to save?"
            onSubmitConfirm={() => {
              onClickCalculateAndSave();
              setShowSaveWarningModal(false);
            }}
            type="warning"
            confirmText="Update"
            cancelText="Cancel"
            note="Any updates made here will automatically reflect in the Operations module and impact its calculations"
          />
        </div>
      </div>
    </Grid>
  );
}
